<h2 mat-dialog-title>{{ fileName }}</h2>
<mat-dialog-content class="document-dialog mat-typography">
  <p><object [data]="sanitizedDataUri" height="100vh" type="application/pdf" width="100%"></object></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
